import * as modalActions from "../actions/modal.action";

const modal = (state = { modalDisplayed: false, modalType: null }, action) => {
  switch (action.type) {
    case modalActions.SHOW_MODAL:
      return Object.assign({}, state, {
        modalDisplayed: true,
        modalType: action.modalType,
        ownProps: action.ownProps,
      });
    case modalActions.HIDE_MODAL:
      window.scrollTo(0, state.scrollPosition);
      setTimeout(() => {
        window.scrollTo(0, state.scrollPosition);
      }, 0);

      return Object.assign({}, state, {
        modalDisplayed: false,
        modalType: null,
        scrollPosition: 0,
        ownProps: null,
      });
    default:
      return state;
  }
};
export default modal;
